import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import AccountLinks from '../../../containers/AccountLinks';
import LogInButtons from '../../LogInButtons/LogInButtons';

import styles from './AccountMenuContent.scss';

function AccountMenuContent(props) {
    const {
        isLoggedIn,
        onComplete,
        onLogOut,
    } = props;

    const _onLogOut = () => {
        onLogOut();
        onComplete();
    };

    return (
        <nav className={styles.menu}>
            {!isLoggedIn && (
                <LogInButtons
                    navType="nav_bar"
                    onClick={onComplete}
                />
            )}
            <div
                className={classNames(
                    styles.linksContainer,
                    { [styles.isLoggedIn]: isLoggedIn },
                )}
            >
                <AccountLinks
                    isLoggedIn={isLoggedIn}
                    navType="nav_bar"
                    onClick={onComplete}
                    onLogOut={_onLogOut}
                />
            </div>
        </nav>
    );
}

AccountMenuContent.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    onComplete: PropTypes.func,
    onLogOut: PropTypes.func,
};

AccountMenuContent.defaultProps = {
    onComplete() {},
    onLogOut() {},
};

export { AccountMenuContent };
export default AccountMenuContent;
